/*!
 * cs-theme.js — Crystal Star theme JavaScript bundle
 * ===================================================
 *
 * Modern (ES2020) rebuild of the legacy FFC webpack theme bundle
 * (ffc.js + chunks). Replaces the old ES5/babel/core-js/regenerator build:
 * no polyfills, no axios (native fetch), no rivets, no detect-browser,
 * no quicklink, no dynamic chunks — one self-contained IIFE.
 *
 * Inlined third-party libraries:
 *   - keen-slider v5.5.1        (local const KeenSlider)
 *   - vanilla-lazyload          (local const LazyLoadLib)
 *   - hc-sticky v2.2.7          (local const hcSticky, loaded eagerly;
 *                                originally webpack async chunk 1)
 *
 * Ported components (registry key -> class):
 *   lazy-load          -> LazyLoadComp
 *   lazy-load-trigger  -> LazyLoadTrigger
 *   keen-slider        -> KeenSliderComp
 *   product            -> Product
 *   mega-menus         -> MegaMenu
 *   slide-toggle       -> SlideToggle
 *   toggle-group       -> SlideToggleGroup
 *   add-to-cart        -> AddToCart
 *   sticky             -> StickyElem   (hc-sticky wrapper)
 *   announcement-bar   -> AnnouncementBar
 *   sticky-container   -> Sticky      (closable bottom bar)
 *
 * Plus: Component base class, Helpers (only the functions in use),
 * AjaxApi (fetch-based), Queue, a tiny evx-compatible event bus, and the
 * Theme boot/registry infrastructure (--vh/--vw vars, --scroll-gap-right
 * observer, cart-item-added analytics hook, shopify:section:load/unload).
 *
 * Behavior is intentionally identical to the legacy bundle, including its
 * known quirks, EXCEPT for four deliberate fixes marked "// CS-FIX:".
 * See ffc-legacy-notes.md for the full behavioral spec, quirk catalogue,
 * and markup contracts (data-attributes, events, localStorage keys).
 */
(() => {
  'use strict';

  /* ===================================================================== *
   *  LIBRARY: keen-slider v5.5.1 (https://keen-slider.io) — MIT
   *  Converted from the original ESM build; `o` is the default export.
   * ===================================================================== */
  const KeenSlider = (() => {
function t(t,n,e){return n in t?Object.defineProperty(t,n,{value:e,enumerable:!0,configurable:!0,writable:!0}):t[n]=e,t}function n(t,n){var e=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(t,n).enumerable}))),e.push.apply(e,r)}return e}function e(e){for(var r=1;r<arguments.length;r++){var i=null!=arguments[r]?arguments[r]:{};r%2?n(Object(i),!0).forEach((function(n){t(e,n,i[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(i)):n(Object(i)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(i,t))}))}return e}function r(t){return function(t){if(Array.isArray(t))return i(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||function(t,n){if(!t)return;if("string"==typeof t)return i(t,n);var e=Object.prototype.toString.call(t).slice(8,-1);"Object"===e&&t.constructor&&(e=t.constructor.name);if("Map"===e||"Set"===e)return Array.from(t);if("Arguments"===e||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))return i(t,n)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function i(t,n){(null==n||n>t.length)&&(n=t.length);for(var e=0,r=new Array(n);e<n;e++)r[e]=t[e];return r}function o(t){var n,i,o,a,f,s,l,d,h,v,p,m,b,g,w,y,M,O,S,A,j,k,x,P,E,T,D,C,L,V,X,Y,z,H,I=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},q="data-keen-slider-moves",F="data-keen-slider-v",W=[],_=null,N=!1,R=!1,U=0,$=[];function B(t,n,e){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};t.addEventListener(n,e,r),W.push([t,n,e,r])}function G(t){if(O&&S===Z(t)&&ft()){var e=nt(t).x;if(!rt(t)&&P)return K(t);P&&(Nt(),A=e,P=!1),t.cancelable&&t.preventDefault();var r=A-e;E+=Math.abs(r),!T&&E>5&&(T=!0,n.setAttribute(q,!0)),Yt(x(r,Jt)*(lt()?-1:1),t.timeStamp),A=e}}function J(t){O||!ft()||et(t.target)||(O=!0,P=!0,S=Z(t),T=!1,E=0,rt(t),pt(),M=v,A=nt(t).x,Yt(0,t.timeStamp),ut("dragStart"))}function K(t){O&&S===Z(t,!0)&&ft()&&(n.removeAttribute(q),O=!1,gt(),ut("dragEnd"))}function Q(t){return t.changedTouches}function Z(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],e=n?Q(t):tt(t);return e?e[0]?e[0].identifier:"error":"default"}function tt(t){return t.targetTouches}function nt(t){var n=tt(t);return{x:ht()?n?n[0].screenY:t.pageY:n?n[0].screenX:t.pageX,timestamp:t.timeStamp}}function et(t){return t.hasAttribute(y.preventEvent)}function rt(t){var n=tt(t);if(!n)return!0;var e=n[0],r=ht()?e.clientY:e.clientX,i=ht()?e.clientX:e.clientY,o=void 0!==j&&void 0!==k&&Math.abs(k-i)<=Math.abs(j-r);return j=r,k=i,o}function it(t){ft()&&O&&t.preventDefault()}function ot(){B(window,"orientationchange",Dt),B(window,"resize",(function(){return Tt()})),B(n,"dragstart",(function(t){ft()&&t.preventDefault()})),B(n,"mousedown",J),B(y.cancelOnLeave?n:window,"mousemove",G),y.cancelOnLeave&&B(n,"mouseleave",K),B(window,"mouseup",K),B(n,"touchstart",J,{passive:!0}),B(n,"touchmove",G,{passive:!1}),B(n,"touchend",K,{passive:!0}),B(n,"touchcancel",K,{passive:!0}),B(window,"wheel",it,{passive:!1})}function at(){W.forEach((function(t){t[0].removeEventListener(t[1],t[2],t[3])})),W=[]}function ut(t){y[t]&&y[t](Jt)}function ct(){return y.centered}function ft(){return void 0!==i?i:y.controls}function st(){return y.loop&&o>1}function lt(){return y.rtl}function dt(){return!y.loop&&y.rubberband}function ht(){return!!y.vertical}function vt(){D=window.requestAnimationFrame(mt)}function pt(){D&&(window.cancelAnimationFrame(D),D=null),C=null}function mt(t){C||(C=t);var n=t-C,e=bt(n);if(n>=V)return Yt(L-Y,!1),H?H():void ut("afterChange");var r=zt(e);if(0===r||st()||dt()||z){if(0!==r&&dt()&&!z)return St();Y+=e,Yt(e,!1),vt()}else Yt(e-r,!1)}function bt(t){return L*X(t/V)-Y}function gt(){switch(ut("beforeChange"),y.mode){case"free":Mt();break;case"free-snap":Ot();break;case"snap":default:wt()}}function wt(){yt((1===l&&0!==p?M:v)+Math.sign(p))}function yt(t,n){var e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:y.duration,r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i=arguments.length>4&&void 0!==arguments[4]&&arguments[4],o=function(t){return 1+--t*t*t*t*t};At(Ft(t=qt(t,r,i)),e,o,n)}function Mt(){if(0===b)return!(!zt(0)||st())&&yt(v);var t=y.friction/Math.pow(Math.abs(b),-.5);At(Math.pow(b,2)/t*Math.sign(b),6*Math.abs(b/t),(function(t){return 1-Math.pow(1-t,5)}))}function Ot(){if(0===b)return yt(v);var t=y.friction/Math.pow(Math.abs(b),-.5),n=Math.pow(b,2)/t*Math.sign(b),e=6*Math.abs(b/t),r=(U+n)/(s/l);At((-1===p?Math.floor(r):Math.ceil(r))*(s/l)-U,e,(function(t){return 1-Math.pow(1-t,5)}))}function St(){if(pt(),0===b)return yt(v,!0);var t=.04/Math.pow(Math.abs(b),-.5),n=Math.pow(b,2)/t*Math.sign(b),e=function(t){return--t*t*t+1},r=b;At(n,3*Math.abs(r/t),e,!0,(function(){At(Ft(qt(v)),500,e,!0)}))}function At(t,n,e,r,i){pt(),L=t,Y=0,V=n,X=e,z=r,H=i,C=null,vt()}function jt(e){var r=u(t);r.length&&(n=r[0],Tt(e),ot(),ut("mounted"))}function kt(){var t,n=I.breakpoints||[];for(var r in n)window.matchMedia(r).matches&&(t=r);if(t===_)return!0;var i=(_=t)?n[_]:I;i.breakpoints&&_&&delete i.breakpoints,y=e(e(e({},Gt),I),i),N=!0,h=null,ut("optionsChanged"),Et()}function xt(t){if("function"==typeof t)return t();var n=y.autoAdjustSlidesPerView;n||(o=Math.max(t,o));var e=st()&&n?o-1:o;return c(t,1,Math.max(e,1))}function Pt(){kt(),R=!0,ut("created")}function Et(t,n){t&&(I=t),n&&(_=null),Ct(),jt(n)}function Tt(t){var e=window.innerWidth;if(kt()&&(e!==h||t)){h=e;var r=y.slides;"number"==typeof r?(f=null,o=r):(f=u(r,n),o=f?f.length:0);var i=y.dragSpeed;x="function"==typeof i?i:function(t){return t*i},s=ht()?n.offsetHeight:n.offsetWidth,l=xt(y.slidesPerView),d=c(y.spacing,0,s/(l-1)-1),s+=d,a=ct()?(s/2-s/l/2)/s:0,Vt();var p=!R||N&&y.resetSlide?y.initial:v;Bt(st()?p:Ht(p)),ht()&&n.setAttribute(F,!0),N=!1}}function Dt(t){Tt(),setTimeout(Tt,500),setTimeout(Tt,2e3)}function Ct(){at(),Xt(),n&&n.hasAttribute(F)&&n.removeAttribute(F),ut("destroyed")}function Lt(){f&&f.forEach((function(t,n){var e=g[n].distance*s-n*(s/l-d/l-d/l*(l-1)),r=ht()?0:e,i=ht()?e:0,o="translate3d(".concat(r,"px, ").concat(i,"px, 0)");t.style.transform=o,t.style["-webkit-transform"]=o}))}function Vt(){f&&f.forEach((function(t){var n="calc(".concat(100/l,"% - ").concat(d/l*(l-1),"px)");ht()?(t.style["min-height"]=n,t.style["max-height"]=n):(t.style["min-width"]=n,t.style["max-width"]=n)}))}function Xt(){if(f){var t=["transform","-webkit-transform"];t=[].concat(r(t),ht?["min-height","max-height"]:["min-width","max-width"]),f.forEach((function(n){t.forEach((function(t){n.style.removeProperty(t)}))}))}}function Yt(t){var n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:Date.now();_t(t,e),n&&(t=Ut(t)),U+=t,Rt()}function zt(t){var n=s*(o-1*(ct()?1:l))/l,e=U+t;return e>n?e-n:e<0?e:0}function Ht(t){return c(t,0,o-1-(ct()?0:l-1))}function It(){var t=Math.abs(w),n=U<0?1-t:t;return{direction:p,progressTrack:n,progressSlides:n*o/(o-1),positions:g,position:U,speed:b,relativeSlide:(v%o+o)%o,absoluteSlide:v,size:o,slidesPerView:l,widthOrHeight:s}}function qt(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],e=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return st()?n?Wt(t,e):t:Ht(t)}function Ft(t){return-(-s/l*t+U)}function Wt(t,n){var e=(v%o+o)%o,r=e<(t=(t%o+o)%o)?-e-o+t:-(e-t),i=e>t?o-e+t:t-e,a=n?Math.abs(r)<=i?r:i:t<e?r:i;return v+a}function _t(t,n){clearTimeout(m);var e=Math.sign(t);if(e!==p&&Nt(),p=e,$.push({distance:t,time:n}),m=setTimeout((function(){$=[],b=0}),50),($=$.slice(-6)).length<=1||0===p)return b=0;var r=$.slice(0,-1).reduce((function(t,n){return t+n.distance}),0),i=$[$.length-1].time,o=$[0].time;b=c(r/(i-o),-10,10)}function Nt(){$=[]}function Rt(){w=st()?U%(s*o/l)/(s*o/l):U/(s*o/l),$t();for(var t=[],n=0;n<o;n++){var e=(1/o*n-(w<0&&st()?w+1:w))*o/l+a;st()&&(e+=e>(o-1)/l?-o/l:e<-o/l+1?o/l:0);var r=1/l,i=e+r,u=i<r?i/r:i>1?1-(i-1)*l/1:1;t.push({portion:u<0||u>1?0:u,distance:lt()?-1*e+1-r:e})}g=t,Lt(),ut("move")}function Ut(t){if(st())return t;var n=zt(t);if(!dt())return t-n;if(0===n)return t;var e;return t*(e=n/s,(1-Math.abs(e))*(1-Math.abs(e)))}function $t(){var t=Math.round(U/(s/l));t!==v&&(!st()&&(t<0||t>o-1)||(v=t,ut("slideChanged")))}function Bt(t){ut("beforeChange"),Yt(Ft(t),!1),ut("afterChange")}var Gt={autoAdjustSlidesPerView:!0,centered:!1,breakpoints:null,controls:!0,dragSpeed:1,friction:.0025,loop:!1,initial:0,duration:500,preventEvent:"data-keen-slider-pe",slides:".keen-slider__slide",vertical:!1,resetSlide:!1,slidesPerView:1,spacing:0,mode:"snap",rtl:!1,rubberband:!0,cancelOnLeave:!0},Jt={controls:function(t){i=t},destroy:Ct,refresh:function(t){Et(t,!0)},next:function(){yt(v+1,!0)},prev:function(){yt(v-1,!0)},moveToSlide:function(t,n){yt(t,!0,n)},moveToSlideRelative:function(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],e=arguments.length>2?arguments[2]:void 0;yt(t,!0,e,!0,n)},resize:function(){Tt(!0)},details:function(){return It()},options:function(){var t=e({},y);return delete t.breakpoints,t}};return Pt(),Jt}function a(t){return Array.prototype.slice.call(t)}function u(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:document;return"function"==typeof t?a(t()):"string"==typeof t?a(n.querySelectorAll(t)):t instanceof HTMLElement!=!1?[t]:t instanceof NodeList!=!1?t:[]}function c(t,n,e){return Math.min(Math.max(t,n),e)}Math.sign||(Math.sign=function(t){return(t>0)-(t<0)||+t});
    return o;
  })();

  /* ===================================================================== *
   *  LIBRARY: vanilla-lazyload (https://github.com/verlok/vanilla-lazyload)
   *  — MIT. Converted from the original UMD build.
   * ===================================================================== */
  const LazyLoadLib = (function(){"use strict";function n(){return n=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(n[i]=e[i])}return n},n.apply(this,arguments)}var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),i=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),a=t&&window.devicePixelRatio>1,r={elements_selector:".lazy",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",data_bg_hidpi:"bg-hidpi",data_bg_multi:"bg-multi",data_bg_multi_hidpi:"bg-multi-hidpi",data_poster:"poster",class_applied:"applied",class_loading:"loading",class_loaded:"loaded",class_error:"error",class_entered:"entered",class_exited:"exited",unobserve_completed:!0,unobserve_entered:!1,cancel_on_exit:!0,callback_enter:null,callback_exit:null,callback_applied:null,callback_loading:null,callback_loaded:null,callback_error:null,callback_finish:null,callback_cancel:null,use_native:!1},c=function(t){return n({},r,t)},u=function(n,t){var e,i="LazyLoad::Initialized",o=new n(t);try{e=new CustomEvent(i,{detail:{instance:o}})}catch(n){(e=document.createEvent("CustomEvent")).initCustomEvent(i,!1,!1,{instance:o})}window.dispatchEvent(e)},l="src",s="srcset",f="sizes",d="poster",_="llOriginalAttrs",g="loading",v="loaded",b="applied",p="error",h="native",m="data-",E="ll-status",I=function(n,t){return n.getAttribute(m+t)},y=function(n){return I(n,E)},A=function(n,t){return function(n,t,e){var i="data-ll-status";null!==e?n.setAttribute(i,e):n.removeAttribute(i)}(n,0,t)},k=function(n){return A(n,null)},L=function(n){return null===y(n)},w=function(n){return y(n)===h},x=[g,v,b,p],O=function(n,t,e,i){n&&(void 0===i?void 0===e?n(t):n(t,e):n(t,e,i))},N=function(n,t){o?n.classList.add(t):n.className+=(n.className?" ":"")+t},C=function(n,t){o?n.classList.remove(t):n.className=n.className.replace(new RegExp("(^|\\s+)"+t+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},M=function(n){return n.llTempImage},z=function(n,t){if(t){var e=t._observer;e&&e.unobserve(n)}},R=function(n,t){n&&(n.loadingCount+=t)},T=function(n,t){n&&(n.toLoadCount=t)},G=function(n){for(var t,e=[],i=0;t=n.children[i];i+=1)"SOURCE"===t.tagName&&e.push(t);return e},D=function(n,t){var e=n.parentNode;e&&"PICTURE"===e.tagName&&G(e).forEach(t)},V=function(n,t){G(n).forEach(t)},F=[l],j=[l,d],P=[l,s,f],S=function(n){return!!n[_]},U=function(n){return n[_]},$=function(n){return delete n[_]},q=function(n,t){if(!S(n)){var e={};t.forEach((function(t){e[t]=n.getAttribute(t)})),n[_]=e}},H=function(n,t){if(S(n)){var e=U(n);t.forEach((function(t){!function(n,t,e){e?n.setAttribute(t,e):n.removeAttribute(t)}(n,t,e[t])}))}},B=function(n,t,e){N(n,t.class_loading),A(n,g),e&&(R(e,1),O(t.callback_loading,n,e))},J=function(n,t,e){e&&n.setAttribute(t,e)},K=function(n,t){J(n,f,I(n,t.data_sizes)),J(n,s,I(n,t.data_srcset)),J(n,l,I(n,t.data_src))},Q={IMG:function(n,t){D(n,(function(n){q(n,P),K(n,t)})),q(n,P),K(n,t)},IFRAME:function(n,t){q(n,F),J(n,l,I(n,t.data_src))},VIDEO:function(n,t){V(n,(function(n){q(n,F),J(n,l,I(n,t.data_src))})),q(n,j),J(n,d,I(n,t.data_poster)),J(n,l,I(n,t.data_src)),n.load()}},W=["IMG","IFRAME","VIDEO"],X=function(n,t){!t||function(n){return n.loadingCount>0}(t)||function(n){return n.toLoadCount>0}(t)||O(n.callback_finish,t)},Y=function(n,t,e){n.addEventListener(t,e),n.llEvLisnrs[t]=e},Z=function(n,t,e){n.removeEventListener(t,e)},nn=function(n){return!!n.llEvLisnrs},tn=function(n){if(nn(n)){var t=n.llEvLisnrs;for(var e in t){var i=t[e];Z(n,e,i)}delete n.llEvLisnrs}},en=function(n,t,e){!function(n){delete n.llTempImage}(n),R(e,-1),function(n){n&&(n.toLoadCount-=1)}(e),C(n,t.class_loading),t.unobserve_completed&&z(n,e)},on=function(n,t,e){var i=M(n)||n;nn(i)||function(n,t,e){nn(n)||(n.llEvLisnrs={});var i="VIDEO"===n.tagName?"loadeddata":"load";Y(n,i,t),Y(n,"error",e)}(i,(function(o){!function(n,t,e,i){var o=w(t);en(t,e,i),N(t,e.class_loaded),A(t,v),O(e.callback_loaded,t,i),o||X(e,i)}(0,n,t,e),tn(i)}),(function(o){!function(n,t,e,i){var o=w(t);en(t,e,i),N(t,e.class_error),A(t,p),O(e.callback_error,t,i),o||X(e,i)}(0,n,t,e),tn(i)}))},an=function(n,t,e){!function(n){n.llTempImage=document.createElement("IMG")}(n),on(n,t,e),function(n){S(n)||(n[_]={backgroundImage:n.style.backgroundImage})}(n),function(n,t,e){var i=I(n,t.data_bg),o=I(n,t.data_bg_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage='url("'.concat(r,'")'),M(n).setAttribute(l,r),B(n,t,e))}(n,t,e),function(n,t,e){var i=I(n,t.data_bg_multi),o=I(n,t.data_bg_multi_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage=r,function(n,t,e){N(n,t.class_applied),A(n,b),e&&(t.unobserve_completed&&z(n,t),O(t.callback_applied,n,e))}(n,t,e))}(n,t,e)},rn=function(n,t,e){!function(n){return W.indexOf(n.tagName)>-1}(n)?an(n,t,e):function(n,t,e){on(n,t,e),function(n,t,e){var i=Q[n.tagName];i&&(i(n,t),B(n,t,e))}(n,t,e)}(n,t,e)},cn=function(n){n.removeAttribute(l),n.removeAttribute(s),n.removeAttribute(f)},un=function(n){D(n,(function(n){H(n,P)})),H(n,P)},ln={IMG:un,IFRAME:function(n){H(n,F)},VIDEO:function(n){V(n,(function(n){H(n,F)})),H(n,j),n.load()}},sn=function(n,t){(function(n){var t=ln[n.tagName];t?t(n):function(n){if(S(n)){var t=U(n);n.style.backgroundImage=t.backgroundImage}}(n)})(n),function(n,t){L(n)||w(n)||(C(n,t.class_entered),C(n,t.class_exited),C(n,t.class_applied),C(n,t.class_loading),C(n,t.class_loaded),C(n,t.class_error))}(n,t),k(n),$(n)},fn=["IMG","IFRAME","VIDEO"],dn=function(n){return n.use_native&&"loading"in HTMLImageElement.prototype},_n=function(n,t,e){n.forEach((function(n){return function(n){return n.isIntersecting||n.intersectionRatio>0}(n)?function(n,t,e,i){var o=function(n){return x.indexOf(y(n))>=0}(n);A(n,"entered"),N(n,e.class_entered),C(n,e.class_exited),function(n,t,e){t.unobserve_entered&&z(n,e)}(n,e,i),O(e.callback_enter,n,t,i),o||rn(n,e,i)}(n.target,n,t,e):function(n,t,e,i){L(n)||(N(n,e.class_exited),function(n,t,e,i){e.cancel_on_exit&&function(n){return y(n)===g}(n)&&"IMG"===n.tagName&&(tn(n),function(n){D(n,(function(n){cn(n)})),cn(n)}(n),un(n),C(n,e.class_loading),R(i,-1),k(n),O(e.callback_cancel,n,t,i))}(n,t,e,i),O(e.callback_exit,n,t,i))}(n.target,n,t,e)}))},gn=function(n){return Array.prototype.slice.call(n)},vn=function(n){return n.container.querySelectorAll(n.elements_selector)},bn=function(n){return function(n){return y(n)===p}(n)},pn=function(n,t){return function(n){return gn(n).filter(L)}(n||vn(t))},hn=function(n,e){var o=c(n);this._settings=o,this.loadingCount=0,function(n,t){i&&!dn(n)&&(t._observer=new IntersectionObserver((function(e){_n(e,n,t)}),function(n){return{root:n.container===document?null:n.container,rootMargin:n.thresholds||n.threshold+"px"}}(n)))}(o,this),function(n,e){t&&window.addEventListener("online",(function(){!function(n,t){var e;(e=vn(n),gn(e).filter(bn)).forEach((function(t){C(t,n.class_error),k(t)})),t.update()}(n,e)}))}(o,this),this.update(e)};return hn.prototype={update:function(n){var t,o,a=this._settings,r=pn(n,a);T(this,r.length),!e&&i?dn(a)?function(n,t,e){n.forEach((function(n){-1!==fn.indexOf(n.tagName)&&function(n,t,e){n.setAttribute("loading","lazy"),on(n,t,e),function(n,t){var e=Q[n.tagName];e&&e(n,t)}(n,t),A(n,h)}(n,t,e)})),T(e,0)}(r,a,this):(o=r,function(n){n.disconnect()}(t=this._observer),function(n,t){t.forEach((function(t){n.observe(t)}))}(t,o)):this.loadAll(r)},destroy:function(){this._observer&&this._observer.disconnect(),vn(this._settings).forEach((function(n){$(n)})),delete this._observer,delete this._settings,delete this.loadingCount,delete this.toLoadCount},loadAll:function(n){var t=this,e=this._settings;pn(n,e).forEach((function(n){z(n,t),rn(n,e,t)}))},restoreAll:function(){var n=this._settings;vn(n).forEach((function(t){sn(t,n)}))}},hn.load=function(n,t){var e=c(t);rn(n,e)},hn.resetStatus=function(n){k(n)},t&&function(n,t){if(t)if(t.length)for(var e,i=0;e=t[i];i+=1)u(n,e);else u(n,t)}(hn,window.lazyLoadOptions),hn})();

  /* ===================================================================== *
   *  LIBRARY: hc-sticky v2.2.7 (https://github.com/somewebmedia/hc-sticky)
   *  — MIT. Converted from the original UMD build; loaded eagerly instead
   *  of the legacy dynamic webpack chunk. The second IIFE attaches the
   *  library's Helpers object (required at instance construction time).
   * ===================================================================== */
  const hcSticky = (function(V){var i,n,Q=V.document,U={top:0,bottom:0,bottomEnd:0,innerTop:0,innerSticker:null,stickyClass:"sticky",stickTo:null,followScroll:!0,responsive:null,mobileFirst:!1,onStart:null,onStop:null,onBeforeResize:null,onResize:null,resizeDebounce:100,disable:!1},Y=function(t,e,o){console.warn("%cHC Sticky:%c "+o+"%c '"+t+"'%c is now deprecated and will be removed. Use%c '"+e+"'%c instead.","color: #fa253b","color: default","color: #5595c6","color: default","color: #5595c6","color: default")},$=function(n,f){var o=this;if(f=f||{},!(n="string"==typeof n?Q.querySelector(n):n))return!1;f.queries&&Y("queries","responsive","option"),f.queryFlow&&Y("queryFlow","mobileFirst","option");var p={},u=$.Helpers,s=n.parentNode;"static"===u.getStyle(s,"position")&&(s.style.position="relative");function d(t){u.isEmptyObject(t=t||{})&&!u.isEmptyObject(p)||(p=Object.assign({},U,p,t))}function t(){return p.disable}function e(){var t,e=p.responsive||p.queries;if(e){var o=V.innerWidth;if(t=f,(p=Object.assign({},U,t||{})).mobileFirst)for(var i in e)i<=o&&!u.isEmptyObject(e[i])&&d(e[i]);else{var n,s=[];for(n in e){var r={};r[n]=e[n],s.push(r)}for(var l=s.length-1;0<=l;l--){var a=s[l],c=Object.keys(a)[0];o<=c&&!u.isEmptyObject(a[c])&&d(a[c])}}}}function i(){var t,e,o,i;I.css=(t=n,e=u.getCascadedStyle(t),o=u.getStyle(t),i={height:t.offsetHeight+"px",left:e.left,right:e.right,top:e.top,bottom:e.bottom,position:o.position,display:o.display,verticalAlign:o.verticalAlign,boxSizing:o.boxSizing,marginLeft:e.marginLeft,marginRight:e.marginRight,marginTop:e.marginTop,marginBottom:e.marginBottom,paddingLeft:e.paddingLeft,paddingRight:e.paddingRight},e.float&&(i.float=e.float||"none"),e.cssFloat&&(i.cssFloat=e.cssFloat||"none"),o.MozBoxSizing&&(i.MozBoxSizing=o.MozBoxSizing),i.width="auto"!==e.width?e.width:"border-box"===i.boxSizing||"border-box"===i.MozBoxSizing?t.offsetWidth+"px":o.width,i),P.init(),y=!(!p.stickTo||!("document"===p.stickTo||p.stickTo.nodeType&&9===p.stickTo.nodeType||"object"==typeof p.stickTo&&p.stickTo instanceof("undefined"!=typeof HTMLDocument?HTMLDocument:Document))),h=p.stickTo?y?Q:u.getElement(p.stickTo):s,z=(R=function(){var t=n.offsetHeight+(parseInt(I.css.marginTop)||0)+(parseInt(I.css.marginBottom)||0),e=(z||0)-t;return-1<=e&&e<=1?z:t})(),v=(H=function(){return y?Math.max(Q.documentElement.clientHeight,Q.body.scrollHeight,Q.documentElement.scrollHeight,Q.body.offsetHeight,Q.documentElement.offsetHeight):h.offsetHeight})(),S=y?0:u.offset(h).top,w=p.stickTo?y?0:u.offset(s).top:S,E=V.innerHeight,N=n.offsetTop-(parseInt(I.css.marginTop)||0),b=u.getElement(p.innerSticker),L=isNaN(p.top)&&-1<p.top.indexOf("%")?parseFloat(p.top)/100*E:p.top,k=isNaN(p.bottom)&&-1<p.bottom.indexOf("%")?parseFloat(p.bottom)/100*E:p.bottom,x=b?b.offsetTop:p.innerTop||0,T=isNaN(p.bottomEnd)&&-1<p.bottomEnd.indexOf("%")?parseFloat(p.bottomEnd)/100*E:p.bottomEnd,j=S-L+x+N}function r(){z=R(),v=H(),O=S+v-L-T,C=E<z;var t,e=V.pageYOffset||Q.documentElement.scrollTop,o=u.offset(n).top,i=o-e;B=e<F?"up":"down",A=e-F,j<(F=e)?O+L+(C?k:0)-(p.followScroll&&C?0:L)<=e+z-x-(E-(j-x)<z-x&&p.followScroll&&0<(t=z-E-x)?t:0)?I.release({position:"absolute",bottom:w+s.offsetHeight-O-L}):C&&p.followScroll?"down"==B?i+z+k<=E+.9?I.stick({bottom:k}):"fixed"===I.position&&I.release({position:"absolute",top:o-L-j-A+x}):Math.ceil(i+x)<0&&"fixed"===I.position?I.release({position:"absolute",top:o-L-j+x-A}):e+L-x<=o&&I.stick({top:L-x}):I.stick({top:L-x}):I.release({stop:!0})}function l(){M&&(V.removeEventListener("scroll",r,u.supportsPassive),M=!1)}function a(){null!==n.offsetParent&&"none"!==u.getStyle(n,"display")?(i(),v<z?l():(r(),M||(V.addEventListener("scroll",r,u.supportsPassive),M=!0))):l()}function c(){n.style.position="",n.style.left="",n.style.top="",n.style.bottom="",n.style.width="",n.classList?n.classList.remove(p.stickyClass):n.className=n.className.replace(new RegExp("(^|\\b)"+p.stickyClass.split(" ").join("|")+"(\\b|$)","gi")," "),I.css={},!(I.position=null)===P.isAttached&&P.detach()}function g(){c(),e(),(t()?l:a)()}function m(){q&&(V.removeEventListener("resize",W,u.supportsPassive),q=!1),l()}var y,h,b,v,S,w,E,L,k,x,T,j,O,C,z,N,H,R,A,B,I={css:{},position:null,stick:function(t){t=t||{},u.hasClass(n,p.stickyClass)||(!1===P.isAttached&&P.attach(),I.position="fixed",n.style.position="fixed",n.style.left=P.offsetLeft+"px",n.style.width=P.width,void 0===t.bottom?n.style.bottom="auto":n.style.bottom=t.bottom+"px",void 0===t.top?n.style.top="auto":n.style.top=t.top+"px",n.classList?n.classList.add(p.stickyClass):n.className+=" "+p.stickyClass,p.onStart&&p.onStart.call(n,Object.assign({},p)))},release:function(t){var e;(t=t||{}).stop=t.stop||!1,!0!==t.stop&&"fixed"!==I.position&&null!==I.position&&(void 0===t.top&&void 0===t.bottom||void 0!==t.top&&(parseInt(u.getStyle(n,"top"))||0)===t.top||void 0!==t.bottom&&(parseInt(u.getStyle(n,"bottom"))||0)===t.bottom)||(!0===t.stop?!0===P.isAttached&&P.detach():!1===P.isAttached&&P.attach(),e=t.position||I.css.position,I.position=e,n.style.position=e,n.style.left=!0===t.stop?I.css.left:P.positionLeft+"px",n.style.width=("absolute"!==e?I.css:P).width,void 0===t.bottom?n.style.bottom=!0===t.stop?"":"auto":n.style.bottom=t.bottom+"px",void 0===t.top?n.style.top=!0===t.stop?"":"auto":n.style.top=t.top+"px",n.classList?n.classList.remove(p.stickyClass):n.className=n.className.replace(new RegExp("(^|\\b)"+p.stickyClass.split(" ").join("|")+"(\\b|$)","gi")," "),p.onStop&&p.onStop.call(n,Object.assign({},p)))}},P={el:Q.createElement("div"),offsetLeft:null,positionLeft:null,width:null,isAttached:!1,init:function(){for(var t in P.el.className="sticky-spacer",I.css)P.el.style[t]=I.css[t];P.el.style["z-index"]="-1";var e=u.getStyle(n);P.offsetLeft=u.offset(n).left-(parseInt(e.marginLeft)||0),P.positionLeft=u.position(n).left,P.width=u.getStyle(n,"width")},attach:function(){s.insertBefore(P.el,n),P.isAttached=!0},detach:function(){P.el=s.removeChild(P.el),P.isAttached=!1}},F=V.pageYOffset||Q.documentElement.scrollTop,M=!1,q=!1,D=function(){p.onBeforeResize&&p.onBeforeResize.call(n,Object.assign({},p)),g(),p.onResize&&p.onResize.call(n,Object.assign({},p))},W=p.resizeDebounce?u.debounce(D,p.resizeDebounce):D,D=function(){q||(V.addEventListener("resize",W,u.supportsPassive),q=!0),e(),(t()?l:a)()};this.options=function(t){return t?p[t]:Object.assign({},p)},this.refresh=g,this.update=function(t){d(t),f=Object.assign({},f,t||{}),g()},this.attach=D,this.detach=m,this.destroy=function(){m(),c()},this.triggerMethod=function(t,e){"function"==typeof o[t]&&o[t](e)},this.reinit=function(){Y("reinit","refresh","method"),g()},d(f),D(),V.addEventListener("load",g)};return void 0!==V.jQuery&&(i=V.jQuery,n="hcSticky",i.fn.extend({hcSticky:function(e,o){return this.length?"options"===e?i.data(this.get(0),n).options():this.each(function(){var t=i.data(this,n);t?t.triggerMethod(e,o):(t=new $(this,e),i.data(this,n,t))}):this}})),V.hcSticky=V.hcSticky||$,$})(window);
  (function(a){var t=a.hcSticky,c=a.document;"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(t,e){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var o=Object(t),i=1;i<arguments.length;i++){var n=arguments[i];if(null!=n)for(var s in n)Object.prototype.hasOwnProperty.call(n,s)&&(o[s]=n[s])}return o},writable:!0,configurable:!0}),Array.prototype.forEach||(Array.prototype.forEach=function(t){var e,o;if(null==this)throw new TypeError("this is null or not defined");var i,n=Object(this),s=n.length>>>0;if("function"!=typeof t)throw new TypeError(t+" is not a function");for(1<arguments.length&&(e=arguments[1]),o=0;o<s;)o in n&&(i=n[o],t.call(e,i,o,n)),o++});var e=!1;try{var o=Object.defineProperty({},"passive",{get:function(){e={passive:!1}}});a.addEventListener("testPassive",null,o),a.removeEventListener("testPassive",null,o)}catch(t){}function n(t,e){return a.getComputedStyle?e?c.defaultView.getComputedStyle(t,null).getPropertyValue(e):c.defaultView.getComputedStyle(t,null):t.currentStyle?e?t.currentStyle[e.replace(/-\w/g,function(t){return t.toUpperCase().replace("-","")})]:t.currentStyle:void 0}function s(t){var e=t.getBoundingClientRect(),o=a.pageYOffset||c.documentElement.scrollTop,t=a.pageXOffset||c.documentElement.scrollLeft;return{top:e.top+o,left:e.left+t}}t.Helpers={supportsPassive:e,isEmptyObject:function(t){for(var e in t)return!1;return!0},debounce:function(i,n,s){var r;return function(){var t=this,e=arguments,o=s&&!r;clearTimeout(r),r=setTimeout(function(){r=null,s||i.apply(t,e)},n),o&&i.apply(t,e)}},hasClass:function(t,e){return t.classList?t.classList.contains(e):new RegExp("(^| )"+e+"( |$)","gi").test(t.className)},offset:s,position:function(t){var e=t.offsetParent,o=s(e),i=s(t),e=n(e),t=n(t);return o.top+=parseInt(e.borderTopWidth)||0,o.left+=parseInt(e.borderLeftWidth)||0,{top:i.top-o.top-(parseInt(t.marginTop)||0),left:i.left-o.left-(parseInt(t.marginLeft)||0)}},getElement:function(t){var e=null;return"string"==typeof t?e=c.querySelector(t):a.jQuery&&t instanceof a.jQuery&&t.length?e=t[0]:t instanceof Element&&(e=t),e},getStyle:n,getCascadedStyle:function(t){var e,o=t.cloneNode(!0);o.style.display="none",Array.prototype.slice.call(o.querySelectorAll('input[type="radio"]')).forEach(function(t){t.removeAttribute("name")}),t.parentNode.insertBefore(o,t.nextSibling),o.currentStyle?e=o.currentStyle:a.getComputedStyle&&(e=c.defaultView.getComputedStyle(o,null));var i,n,s,r={};for(i in e)!isNaN(i)||"string"!=typeof e[i]&&"number"!=typeof e[i]||(r[i]=e[i]);if(Object.keys(r).length<3)for(var l in r={},e)isNaN(l)||(r[e[l].replace(/-\w/g,function(t){return t.toUpperCase().replace("-","")})]=e.getPropertyValue(e[l]));return r.margin||"auto"!==r.marginLeft?r.margin||r.marginLeft!==r.marginRight||r.marginLeft!==r.marginTop||r.marginLeft!==r.marginBottom||(r.margin=r.marginLeft):r.margin="auto",r.margin||"0px"!==r.marginLeft||"0px"!==r.marginRight||(s=(n=t.offsetLeft-t.parentNode.offsetLeft)-(parseInt(r.left)||0)-(parseInt(r.right)||0),0!=(s=t.parentNode.offsetWidth-t.offsetWidth-n-(parseInt(r.right)||0)+(parseInt(r.left)||0)-s)&&1!=s||(r.margin="auto")),o.parentNode.removeChild(o),o=null,r}}})(window);

  /* ===================================================================== *
   *  Event bus — tiny evx replacement (API-compatible subset)
   *
   *  create(initialState) -> { on(name, fn), emit(name, stateUpdate, data),
   *  getState() }. emit merges a non-null stateUpdate object into state,
   *  then calls handlers as fn(state, data) — handlers registered for the
   *  event name, for '*', and for any updated state key (like evx).
   * ===================================================================== */
  const evx = {
    create(initialState = {}) {
      const state = initialState;
      const handlers = {};
      return {
        getState() {
          return Object.assign({}, state);
        },
        on(name, handler) {
          const names = [].concat(name);
          for (const n of names) {
            handlers[n] = (handlers[n] || []).concat(handler);
          }
          return () => names.map((n) => handlers[n].splice(handlers[n].indexOf(handler), 1));
        },
        emit(name, stateUpdate, data) {
          let names = (name === '*' ? [] : ['*']).concat(name);
          const update = typeof stateUpdate === 'function' ? stateUpdate(state) : stateUpdate;
          if (update) {
            Object.assign(state, update);
            names = names.concat(Object.keys(update));
          }
          const called = [];
          for (const n of names) {
            if (called.includes(n)) continue;
            called.push(n);
            for (const handler of handlers[n] || []) {
              handler(state, data);
            }
          }
        },
      };
    },
  };

  /* ===================================================================== *
   *  Queue — sequential async job queue (lives in ctx state as eventQueue;
   *  consumed by SlideToggle's useQueue option)
   * ===================================================================== */
  class Queue {
    constructor() {
      this.queue = [];
      this.processing = false;
    }

    onInit() {}

    add(job) {
      this.queue.push(job);
      if (!this.processing) {
        this.process();
      }
    }

    async process() {
      this.processing = true;
      if (this.queue.length === 0) {
        this.processing = false;
        return false;
      }
      const job = this.queue.shift();
      await job();
      this.process();
    }
  }

  /* ===================================================================== *
   *  Helpers — only the functions actually used by the ported components
   * ===================================================================== */
  class Helpers {
    static formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    // Quirks preserved from the legacy bundle: 0 renders as locale.free, and
    // the trailing ".00"/",00" strips can mangle unusual money formats.
    static formatMoney(cents, state) {
      const format = state.moneyFormat;
      if (cents === 0) return state.locale.free;

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

      switch (format.match(placeholderRegex)[1]) {
        case 'amount':
          value = Helpers.formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = Helpers.formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = Helpers.formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = Helpers.formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = Helpers.formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return format.replace(placeholderRegex, value).replace('.00', '').replace(',00', '');
    }

    static getSizedImageUrl(src, size) {
      if (size === null || src === null) {
        return src;
      }

      if (size === 'master') {
        return Helpers.removeProtocol(src);
      }

      const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match) {
        const prefix = src.split(match[0]);
        const suffix = match[0];
        return Helpers.removeProtocol(prefix[0] + '_' + size + suffix);
      }
      return null;
    }

    static removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    static getEndpoint(endpoint) {
      if (endpoint.includes('?')) {
        return `${endpoint}&v=${Math.random()}`;
      }
      return `${endpoint}?v=${Math.random()}`;
    }

    static nextFrame(callback) {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(callback);
      });
    }

    static compact(array) {
      let index = -1;
      const length = array == null ? 0 : array.length;
      let resIndex = 0;
      const result = [];

      while (++index < length) {
        const value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }

      return result;
    }

    static slideDown(elem, mainElem) {
      elem.style.maxHeight = 'none';
      const scrollHeight = elem.scrollHeight;
      elem.style.maxHeight = '0px';
      mainElem.classList.add('open');
      elem.classList.add('open');
      elem.dataset.transitioning = true;

      const openEvent = (e) => {
        if (e.propertyName === 'max-height') {
          elem.dataset.transitioning = false;
          elem.style.maxHeight = 'none';
          elem.removeEventListener('transitionend', openEvent, false);
        }
      };

      elem.addEventListener('transitionend', openEvent, false);
      Helpers.nextFrame(() => {
        elem.style.maxHeight = `${scrollHeight}px`;
      });
    }

    static slideUp(elem, mainElem) {
      elem.style.maxHeight = `${elem.scrollHeight}px`;
      mainElem.classList.remove('open');
      elem.dataset.transitioning = true;

      const closeEvent = (e) => {
        if (e.propertyName === 'max-height') {
          elem.classList.remove('open');
          elem.dataset.transitioning = false;
          elem.removeEventListener('transitionend', closeEvent, false);
        }
      };

      elem.addEventListener('transitionend', closeEvent, false);
      Helpers.nextFrame(() => {
        elem.style.maxHeight = '0px';
      });
    }
  }

  /* ===================================================================== *
   *  AjaxApi — the only network layer (fetch-based; formerly axios).
   *  Every URL passes through Helpers.getEndpoint (random ?v= cache-buster).
   *  Like axios, requests REJECT on non-2xx responses.
   * ===================================================================== */
  const endpoints = {
    cart: {
      clear: '/cart/clear.json',
      get: '/cart.json',
      add: '/cart/add.js',
      change: '/cart/change.js',
      update: '/cart/update.js',
    },
    product: {
      get: '/products/[handle].json',
      getCustom: '/products/[handle]?view=json',
    },
  };

  class AjaxApi {
    static async _get(endpoint) {
      const response = await fetch(Helpers.getEndpoint(endpoint), {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) {
        throw new Error(`AjaxApi: GET ${endpoint} failed with status ${response.status}`);
      }
      return response.json();
    }

    static async _post(endpoint, options) {
      const response = await fetch(Helpers.getEndpoint(endpoint), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(options),
      });
      if (!response.ok) {
        throw new Error(`AjaxApi: POST ${endpoint} failed with status ${response.status}`);
      }
      return response.json();
    }

    static async getCart() {
      return AjaxApi._get(endpoints.cart.get);
    }

    static async addToCart(options) {
      return AjaxApi._post(endpoints.cart.add, options);
    }

    static async changeCart(options) {
      return AjaxApi._post(endpoints.cart.change, options);
    }

    static async updateCart(options) {
      return AjaxApi._post(endpoints.cart.update, options);
    }

    static async emptyCart(options) {
      return AjaxApi._post(endpoints.cart.clear, options);
    }

    // NOTE: `line` is the 1-based cart LINE number, not a variant id or key.
    static async updateCartItem(id, quantity, props = {}) {
      return AjaxApi.changeCart({ line: `${id}`, quantity: quantity, properties: props });
    }

    static async removeCartItem(id) {
      return AjaxApi.updateCartItem(id, 0);
    }

    static async getProduct(handle) {
      const endpoint = endpoints.product.get.replace('[handle]', handle);
      const data = await AjaxApi._get(endpoint);
      return data.product;
    }

    static async getCustomProduct(handle) {
      const endpoint = endpoints.product.getCustom.replace('[handle]', handle);
      const response = await fetch(Helpers.getEndpoint(endpoint), {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) {
        throw new Error(`AjaxApi: GET ${endpoint} failed with status ${response.status}`);
      }
      const data = await response.text();
      return JSON.parse(data);
    }
  }

  /* ===================================================================== *
   *  Component — base class (responsive options + reinit-on-resize)
   * ===================================================================== */
  class Component {
    constructor(elem, theme, options, ctx) {
      this._theme = theme;
      this._elem = elem;
      this._ctx = ctx;
      this._options = options;
      this._originalOptions = { ...this._options };
      this._addedResizeListener = false;

      this._optionsCheck(true);
    }

    _optionsCheck(firstRun) {
      if (Array.isArray(this._options)) return false;

      let newOptions = { ...this._originalOptions };
      newOptions.usingSettingsFor = 'desktop';

      if (this._originalOptions.responsive && this._originalOptions.responsive.length) {
        for (const optionsObj of this._originalOptions.responsive) {
          if (matchMedia(`only screen and (max-width: ${optionsObj.breakpoint})`).matches) {
            newOptions = { ...this._originalOptions, ...optionsObj.settings };
            newOptions.usingSettingsFor = 'tablet';
          }
        }
      }

      if (firstRun) {
        this._options = newOptions;
      } else if (this._options.usingSettingsFor !== newOptions.usingSettingsFor) {
        this._options = newOptions;
        return true;
      }

      return false;
    }

    reinitOnResize() {
      if (this._addedResizeListener) return;
      window.addEventListener('resize', () => {
        const changed = this._optionsCheck();
        if (changed) {
          this.unmount();
          this.mount();
          Helpers.nextFrame(() => {
            if (typeof this.update === 'function') {
              this.update();
            }
          });
        }
      }, { passive: true });
      this._addedResizeListener = true;
    }
  }

  /* ===================================================================== *
   *  KeenSliderComp — keen-slider v5 wrapper
   * ===================================================================== */
  class KeenSliderComp extends Component {
    constructor(elem, theme, options, ctx) {
      super(elem, theme, options, ctx);
      this._options = {
        slidesPerView: 1,
        dragSpeed: 1,
        autoplaySpeed: 5000,
        duration: 500,
        // Kept although flagged "dead" in the spec: the whole options object
        // is handed to the keen-slider constructor, whose own default for
        // this key is `true` — removing it would change library behavior.
        autoAdjustSlidesPerView: false,
        arrowSvg: `
      <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M.55 13.208c-.473.434-.483.868-.03 1.302.454.434.898.434 1.332 0l6.156-6.155c.197-.158.295-.375.295-.651s-.098-.493-.295-.651L1.852.898C1.418.464.974.464.521.898c-.454.434-.444.868.03 1.302l5.444 5.504L.55 13.208z" fill="#000"/>
      </svg>
      `,
        ...this._options,
      };
      this._slider = null;
      this._autoplayInterval = null;
      this.shouldAutoplay = false;
      this._localCtx = evx.create();
      this._isMounted = false;
      this._arrowKeyHandler = null;

      super.reinitOnResize();
    }

    mount() {
      if (this._options.mount === false) {
        return false;
      }

      if (this._options.enableWhen && !matchMedia(`only screen and ${this._options.enableWhen}`).matches) {
        window.addEventListener('resize', () => {
          if (matchMedia(`only screen and ${this._options.enableWhen}`).matches && !this._isMounted) {
            this.mount();
          } else if (!matchMedia(`only screen and ${this._options.enableWhen}`).matches && this._isMounted) {
            this.unmount();
            this._isMounted = false;
          }
        }, { passive: true });
        return false;
      }

      this._elem.classList.add('keen-slider');

      for (const elem of this._elem.children) {
        if (elem.hasAttribute('data-keen-dots') || elem.hasAttribute('data-keen-nav')) continue;
        elem.classList.add('keen-slider__slide');
        if (this._options.fade) {
          elem.classList.add('fader-slide');
        }
      }

      this._slides = this._elem.querySelectorAll('.keen-slider__slide');

      // AS NAV FOR
      if (this._options.asNavFor) {
        this._ctx.on('ffc--mounted', () => {
          this._parentSlider = this._theme.getComponent(this._options.asNavFor);
          this._parentSlider = this._parentSlider.component;
          this._parentSlider._localCtx.on('slide-change', (state, data) => {
            this.goToSlide(data.slide);
          });
        });
      }

      if (this._options.arrows) this._createArrows();
      if (this._options.dots && this._slides.length > 1) this._createDots();

      if (this._slides.length === this._options.slidesPerView) {
        this._options.loop = false;
        this._options.controls = false;
      }

      this._dotsContainer = this._options.dotsContainer
        ? document.querySelector(this._options.dotsContainer) || this._elem
        : this._elem;
      this._dots = this._dotsContainer.querySelectorAll('[data-dot]');
      if (!this._prevArrow) this._prevArrow = this._elem.querySelector('[data-keen-prev]');
      if (!this._nextArrow) this._nextArrow = this._elem.querySelector('[data-keen-next]');

      this._options.slideChanged = (slider) => {
        this.updateClasses(slider);
        this.updateFadeHeight(slider);
        this._localCtx.emit('slide-change', null, {
          slide: slider.details().relativeSlide,
        });
        this.adaptiveHeight(slider);
        if (this._isMounted) this.scrollRevealFix(slider);
        this._pauseVideos();
        if (this._options.playVideos) this._playVideos(slider);
        if (this._options.setSlideCount) this._setSlideCount(slider);
        this._doSlideCSSVars(slider);
        this.autoplay();
        if (this._options.asNavFor && this._parentSlider) {
          const slide = slider.details().relativeSlide;
          this._parentSlider.goToSlide(slide);
        }
      };

      this._options.created = (slider) => {
        this._elem.classList.add('keen-slider--ready');
        this.updateClasses(slider);
        this.updateFadeHeight(slider);
        this.adaptiveHeight(slider);
        this._doSlideCSSVars(slider);
        if (this._options.autoplay) this._setupAutoplay();
        if (this._options.alignArrowsTo) this.alignArrows();
        if (this._options.arrowKeyNavigation) this._addArrowKeyEvents();
        if (this._options.playVideos) this._playVideos(slider);
        if (this._options.setSlideCount) this._setSlideCount(slider);
        if (this._options.focusOnSelect) this.focusOnSelect(slider);
        window.addEventListener('resize', () => {
          this.updateFadeHeight();
          this.adaptiveHeight();
          if (this._options.alignArrowsTo) {
            Helpers.nextFrame(() => {
              this.alignArrows();
            });
          }
        }, { passive: true });
      };

      this._options.dragStart = () => {
        this.shouldAutoplay = false;
      };

      this._options.dragEnd = () => {
        this.shouldAutoplay = true;
      };

      if (this._options.fade) {
        this._options.move = (slider) => this.fader(slider);
      }

      this._slider = new KeenSlider(this._elem, this._options);

      if (this._prevArrow) {
        this._prevArrow.addEventListener('click', (e) => this.goToPrev(e));
      }
      if (this._nextArrow) {
        this._nextArrow.addEventListener('click', (e) => this.goToNext(e));
      }

      for (const dot of this._dots) {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          const dontAnimate = !!dot.dataset.dotAnimate;
          this.goToSlide(dot.dataset.dot, dontAnimate);
          if (this._parentSlider) {
            this._parentSlider.goToSlide(dot.dataset.dot);
          }
        });
      }

      this._isMounted = true;

      if (this._options.triggerOnMount) {
        this._ctx.emit(this._options.triggerOnMount);
      }
    }

    focusOnSelect(slider = this._slider) {
      for (const [index, slide] of this._slides.entries()) {
        slide.addEventListener('click', () => {
          this.goToSlide(index);
        });
      }
    }

    _setSlideCount(slider = this._slider) {
      const slideCountParentElem = document.querySelector(this._options.setSlideCount);
      const totalElem = slideCountParentElem.querySelector('[data-slide-total]');
      const currentElem = slideCountParentElem.querySelector('[data-slide-current]');
      totalElem.innerHTML = slider.details().size;
      currentElem.innerHTML = slider.details().relativeSlide + 1;

      if (this.isAtEnd(slider) && slider.details().relativeSlide == 0) {
        slideCountParentElem.classList.add('hide');
      }
    }

    unmount() {
      // CS-FIX: the legacy bundle never cleared the autoplay interval on
      // unmount, leaking a timer that kept calling next() on a destroyed
      // slider after every breakpoint crossing.
      if (this._autoplayInterval) {
        clearInterval(this._autoplayInterval);
        this._autoplayInterval = null;
      }

      // CS-FIX: the legacy bundle never removed the arrowKeyNavigation
      // document keydown listener, so every unmount/remount stacked another
      // listener and destroyed sliders still received arrow-key commands.
      if (this._arrowKeyHandler) {
        document.removeEventListener('keydown', this._arrowKeyHandler);
        this._arrowKeyHandler = null;
      }

      this._slider.destroy();

      if (this._navContainer) {
        this._navContainer.parentNode.removeChild(this._navContainer);
      }

      this._elem.classList.remove('keen-slider');

      for (const elem of this._elem.children) {
        elem.classList.remove('keen-slider__slide');
        elem.classList.remove('fader-slide');
        elem.removeAttribute('style');
      }
    }

    _setupAutoplay() {
      this.shouldAutoplay = true;
      this.autoplay();

      if (this._options.pauseAutoplayOnHover) {
        this._elem.addEventListener('mouseover', () => {
          this.shouldAutoplay = false;
        });
        this._elem.addEventListener('mouseout', () => {
          this.shouldAutoplay = true;
        });
      }
    }

    _doSlideCSSVars(slider = this._slider) {
      const slide = this.getActiveSlideElem(slider);

      if (slide && slide.dataset.slideCssVars) {
        const varArr = JSON.parse(slide.dataset.slideCssVars);
        for (const cssVar of varArr) {
          const toSetOn = document.querySelector(cssVar.onElem);
          if (toSetOn) {
            toSetOn.style.setProperty(cssVar.var, cssVar.value);
          }
        }
      }
    }

    _addArrowKeyEvents() {
      // CS-FIX: handler kept on the instance so unmount() can remove it.
      this._arrowKeyHandler = (e) => {
        const ev = e || window.event;
        if (ev.keyCode === 37) {
          // left arrow
          this._slider.prev();
        } else if (ev.keyCode === 39) {
          // right arrow
          this._slider.next();
        }
      };
      document.addEventListener('keydown', this._arrowKeyHandler);
    }

    _createArrows() {
      const e = document.createElement('ul');
      e.classList.add('keen-nav');
      e.setAttribute('data-keen-nav', true);
      e.innerHTML = `
        <li>
          <button data-keen-prev class="keen-arrow-prev keen-arrow" aria-label="Previous Slide">
            ${this._options.arrowSvg || ''}
          </button>
        </li>
        <li>
          <button data-keen-next class="keen-arrow-next keen-arrow" aria-label="Next Slide">
            ${this._options.arrowSvg || ''}
          </button>
        </li>
    `;
      this._navContainer = e;
      this._prevArrow = this._navContainer.querySelector('[data-keen-prev]');
      this._nextArrow = this._navContainer.querySelector('[data-keen-next]');

      if (this._options.appendArrows) {
        const toAppend = document.querySelector(this._options.appendArrows);
        if (toAppend) toAppend.appendChild(e);
      } else {
        this._elem.appendChild(e);
      }
    }

    _createDots() {
      const e = document.createElement('ul');
      e.classList.add('keen-dots');
      e.setAttribute('data-keen-dots', true);
      const dotsToMake = Math.ceil(this._slides.length / this._options.slidesPerView);

      for (let i = 0; i < dotsToMake; i++) {
        e.innerHTML += `
        <li>
          <button data-dot='${i * this._options.slidesPerView}'></button>
        </li>
      `;
      }

      this._elem.classList.add('keen--dotted');
      this._elem.appendChild(e);
    }

    // The legacy hasAttribute('[data-lazy]') lazy-video branch was provably
    // dead (bracketed attribute name never matches) and has been dropped.
    _playVideos(slider = this._slider) {
      this._pauseVideos();

      Helpers.nextFrame(() => {
        const active = this.getActiveSlideElem();
        const activeVideo = active.querySelector('video');
        if (activeVideo) {
          activeVideo.play();
        }
      });
    }

    _pauseVideos() {
      const videos = this._elem.querySelectorAll('video');
      for (const video of videos) {
        video.pause();
      }
    }

    fader(slider = this._slider) {
      const opacities = slider.details().positions.map((slide) => slide.portion);
      for (const [index, slide] of this._slides.entries()) {
        slide.style.opacity = opacities[index];
      }
    }

    goToSlide(index, dontAnimate = false) {
      const duration = dontAnimate ? 0 : 500;
      let nearest = false;

      if (this._options.loop && this._slider.details().size > 2) {
        nearest = true;
      }

      this._slider.moveToSlideRelative(index, nearest, duration);
    }

    goToPrev(e) {
      e.preventDefault();
      this._slider.prev();
    }

    goToNext(e) {
      e.preventDefault();
      this._slider.next();
    }

    scrollRevealFix() {
      for (const slide of this._slides) {
        if (slide.hasAttribute('data-reveal')) {
          slide.style.removeProperty('opacity');
          slide.style.removeProperty('transition');
          slide.style.removeProperty('visibility');
          slide.removeAttribute('data-reveal');
        }
      }
    }

    getActiveSlideElem(slider = this._slider) {
      const slideIndex = slider.details().relativeSlide;
      for (const [index, slide] of this._slides.entries()) {
        if (index === slideIndex) {
          return slide;
        }
      }
      return false;
    }

    adaptiveHeight(slider = this._slider) {
      if (!this._options.adaptiveHeight || !slider) return false;

      this._elem.classList.add('keen--adaptive-height');

      let height = 0;
      height += parseFloat(getComputedStyle(this._elem).paddingBottom);
      height += parseFloat(getComputedStyle(this._elem).paddingTop);
      const activeSlide = this.getActiveSlideElem(slider);
      if (!activeSlide) return;
      height += activeSlide.clientHeight;
      this._elem.style.height = `${height}px`;
    }

    updateFadeHeight(slider = this._slider) {
      if (!this._options.fade || !slider) return false;
      let height = 0;
      height += parseFloat(getComputedStyle(this._elem).paddingBottom);
      height += parseFloat(getComputedStyle(this._elem).paddingTop);
      const activeSlide = this.getActiveSlideElem(slider);
      if (!activeSlide) return;
      height += activeSlide.getBoundingClientRect().height;
      this._elem.style.height = `${height}px`;

      if (!this._elem.classList.contains('fade-slider')) {
        this._elem.classList.add('fade-slider');
      }
    }

    alignArrows() {
      if (!this._options.alignArrowsTo) return false;
      const elem = this._elem.querySelector(this._options.alignArrowsTo);
      this._navContainer.style.top = `${elem.clientHeight / 2}px`;
    }

    updateClasses(slider) {
      if (!slider) return false;
      const slide = slider.details().relativeSlide;
      const maxSlides = slider.details().size;
      const canSlide = slider.details().slidesPerView !== maxSlides;

      if (this._prevArrow && !this._options.loop) {
        if (slide === 0 || !canSlide) {
          this._prevArrow.setAttribute('disabled', 'disabled');
        } else {
          this._prevArrow.removeAttribute('disabled');
        }
      }

      if (this._nextArrow && !this._options.loop) {
        if (this.isAtEnd(slider) || !canSlide) {
          this._nextArrow.setAttribute('disabled', 'disabled');
        } else {
          this._nextArrow.removeAttribute('disabled');
        }
      }

      if (this._dots) {
        const dotIndex = Math.floor(slide / slider.details().slidesPerView) * slider.details().slidesPerView;
        for (const dot of this._dots) {
          dot.classList.remove('active');
          if (Number(dot.dataset.dot) === dotIndex) {
            dot.classList.add('active');
          }
        }
      }

      const activeSlide = this.getActiveSlideElem(slider);

      for (const slideElem of this._slides) {
        slideElem.classList.remove('active');
      }

      if (activeSlide) {
        activeSlide.classList.add('active');
      }
    }

    isAtEnd(slider = this._slider) {
      const slide = slider.details().relativeSlide;
      const maxSlides = slider.details().size;
      const endSlide = slide + Math.floor(slider.details().slidesPerView);
      return endSlide === maxSlides;
    }

    autoplay() {
      if (!this._options.autoplay) {
        if (this._autoplayInterval) clearInterval(this._autoplayInterval);
        return false;
      }

      clearInterval(this._autoplayInterval);
      this._autoplayInterval = null;
      this._autoplayInterval = setInterval(() => {
        if (this.shouldAutoplay && this._slider) {
          if (this.isAtEnd() && !this._options.loop) {
            this.goToSlide(0);
          } else {
            this._slider.next();
          }
        }
      }, this._options.autoplaySpeed);
    }

    refresh() {
      return this._slider.refresh();
    }

    resize() {
      return this._slider.resize();
    }
  }

  /* ===================================================================== *
   *  AddToCart — AJAX add-to-cart for forms and quick-buy buttons
   * ===================================================================== */
  class AddToCart extends Component {
    constructor(elem, theme, options, ctx) {
      super(elem, theme, options, ctx);
      // The legacy addingText option was never used and has been dropped.
      this._options = {
        redirect: null,
        addedText: null,
        waitFor: 1500,
        ...this._options,
      };
      this._variantIdElem = this._elem.querySelector('[name="id"]');
      this._quantityElem = this._elem.querySelector('[name="quantity"]');
      this._submitElems = this._elem.nodeName === 'FORM'
        ? this._elem.querySelectorAll('[type="submit"]')
        : [this._elem];
      this._propertyElems = this._elem.querySelectorAll('[name^="properties"]');
      this._extraProductsInput = this._elem.querySelector('[data-extra-products]');
      this._globalExtraProducts = document.querySelector('[data-extra-atc-products]')
        ? JSON.parse(document.querySelector('[data-extra-atc-products]').innerHTML)
        : [];
    }

    mount() {
      this._addListeners();
    }

    _getProperties() {
      this._propertyElems = this._elem.querySelectorAll('[name^="properties"]');
      let properties = {};
      const propElems = Array.from(this._propertyElems).filter(
        (elem) => !elem.hasAttribute('disabled') && elem.value.length > 0
      );

      for (const elem of propElems) {
        properties[elem.getAttribute('name').match(/^properties\[(.+)\]$/)[1]] = elem.value;
      }

      if (propElems.length === 0 && this._elem.dataset.properties) {
        properties = JSON.parse(this._elem.dataset.properties);
      }

      return properties;
    }

    _addListeners() {
      const event = this._elem.nodeName === 'FORM' ? 'submit' : 'click';

      this._elem.addEventListener(event, async (e) => {
        e.preventDefault();

        for (const elem of this._submitElems) {
          elem.classList.add('ffc--adding-to-cart');
        }

        if (this._options.addedText) {
          for (const elem of this._submitElems) {
            elem.style.minWidth = `${elem.getBoundingClientRect().width}px`;
          }
        }

        const variantId = this._variantIdElem ? this._variantIdElem.value : this._elem.dataset.variantId;
        const quantity = this._quantityElem
          ? Number(this._quantityElem.value)
          : Number(this._elem.dataset.quantity);
        const properties = this._getProperties();
        let items = [{ id: variantId, quantity: quantity, properties: properties }];

        // Add extra products to every atc (if quantity is less)
        if (this._globalExtraProducts.length) {
          const cart = await AjaxApi.getCart();
          const globalProductsToAdd = this._globalExtraProducts
            .filter((product) => {
              const item = cart.items.find((it) => `${it.variant_id}` === `${product.id}`);
              if (item && item.quantity >= product.quantity) {
                return false;
              }
              return true;
            })
            .map((product) => {
              const item = cart.items.find((it) => `${it.variant_id}` === `${product.id}`);
              if (item && item.quantity < product.quantity) {
                // Faithful quirk: mutates the shared object, so quantities
                // shrink cumulatively across successive adds in one session.
                product.quantity -= item.quantity;
              }
              return product;
            });
          items = [...globalProductsToAdd, ...items];
        }

        if (this._extraProductsInput && this._extraProductsInput.value) {
          const extraProducts = JSON.parse(this._extraProductsInput.value);
          for (const prod of extraProducts) {
            items.push({
              id: prod.id,
              quantity: Number(prod.quantity || 1),
              properties: prod.properties || {},
              selling_plan: prod.selling_plan,
            });
          }
        }

        if (this._options.showCompleteRoutine) {
          this._ctx.emit('show-complete-routine-popup', null, {
            handle: this._options.handle,
          });
        }

        let data;
        try {
          data = await AjaxApi.addToCart({ items: items });
        } catch (error) {
          // CS-FIX: the legacy bundle had no error handling — a failed
          // /cart/add.js response (e.g. sold out, 422) left the button stuck
          // with ffc--adding-to-cart forever. Clean up and re-enable instead.
          for (const elem of this._submitElems) {
            elem.classList.remove('ffc--adding-to-cart');
            elem.removeAttribute('disabled');
          }
          console.error(error);
          return;
        }

        for (const item of data.items) {
          const matching = items.find((it) => `${it.id}` === `${item.variant_id}`);
          // CS-FIX: the legacy bundle threw a TypeError here when Shopify
          // merged/renamed lines so that no request line matched a response
          // line; skip the per-line emit instead of crashing the handler.
          if (!matching) continue;
          this._ctx.emit('cart-atc', null, {
            item: item,
            quantity: matching.quantity,
            properties: matching.properties,
          });
        }

        this._ctx.emit('cart-item-added', {
          lastItemAdded: {
            item: data,
            quantity: quantity,
            properties: properties,
          },
        });

        if (!this._options.redirect) {
          for (const elem of this._submitElems) {
            elem.classList.remove('ffc--adding-to-cart');
            elem.classList.add('ffc--added-to-cart');
          }

          if (this._options.addedText) {
            for (const elem of this._submitElems) {
              elem.innerHTML = this._options.addedText;
            }
          }

          setTimeout(() => {
            for (const elem of this._submitElems) {
              elem.classList.remove('ffc--added-to-cart');
            }
          }, this._options.waitFor);
        }

        if (this._options.redirect) {
          window.location = this._options.redirect;
        }
      });
    }
  }

  /* ===================================================================== *
   *  Product — product page controller (variants, prices, media, selling
   *  plans, bundles, Klarna). REVENUE CRITICAL.
   * ===================================================================== */
  class Product extends Component {
    constructor(elem, theme, options, ctx) {
      super(elem, theme, options, ctx);
      this._options = { historyState: true, ...this._options };
      this._product = this._elem.querySelector('[data-product-json]')
        ? JSON.parse(this._elem.querySelector('[data-product-json]').innerHTML)
        : null;
      this._variantOptionTriggers = this._elem.querySelectorAll('[data-variant-option-trigger]');
      this._variant = null;
      this._sellingPlan = null;
      this._masterSelects = this._elem.querySelectorAll('[data-master-select]');
      this._prices = this._elem.querySelectorAll('[data-price]');
      this._priceVaries = this._elem.querySelectorAll('[data-price-varies]');
      this._comparePrices = this._elem.querySelectorAll('[data-compare-price]');
      this._images = this._elem.querySelectorAll('[data-product-image]');
      this._addToCarts = this._elem.querySelectorAll('[data-submit]');
      this._quantityInput = this._elem.querySelector('[data-quantity-input]');
      this._quantitySelects = this._elem.querySelectorAll('[data-quantity]');
      this._variantRadios = this._elem.querySelectorAll('[data-variant-id]');
      this._extraProductsInput = this._elem.querySelector('[data-extra-products]');
      this._extraProductRadios = this._elem.querySelectorAll('[data-extra-product]');
      this._sellingPlanInput = this._elem.querySelector('[data-selling-plan]');
      this._optionDisplays = this._elem.querySelectorAll('[data-option-display]');
      this._klarnaPlacements = this._elem.querySelectorAll('klarna-placement');
      this._bundleProducts = this._elem.querySelectorAll('[data-bundle-product]');
    }

    mount() {
      if (this._product === null) {
        return false;
      }

      this._variant = this._getVariantFromOptions();

      for (const optionSelector of this._variantOptionTriggers) {
        optionSelector.addEventListener('change', () => {
          this._onSelectChange();
        });
      }

      for (const optionSelector of this._variantRadios) {
        optionSelector.addEventListener('change', () => {
          this._onSelectChange();
        });
      }

      for (const optionSelector of this._masterSelects) {
        optionSelector.addEventListener('change', () => {
          this._onSelectChange();
        });
      }

      for (const optionSelector of this._extraProductRadios) {
        optionSelector.addEventListener('change', () => {
          this._onExtraProductRadioChange();
        });
      }

      for (const quantitySwitch of this._quantitySelects) {
        quantitySwitch.addEventListener('change', () => {
          if (quantitySwitch.checked) {
            this._quantityInput.value = quantitySwitch.dataset.quantity;
          }
        });
      }

      this._onSelectChange();
    }

    _onExtraProductRadioChange() {
      const extraProducts = [];

      for (const radio of this._extraProductRadios) {
        if (radio.checked) {
          const obj = JSON.parse(radio.dataset.extraProduct);
          extraProducts.push({
            id: obj.id,
            quantity: obj.quantity,
            selling_plan: obj.selling_plan,
          });
        }
      }

      if (this._extraProductsInput) {
        this._extraProductsInput.value = JSON.stringify(extraProducts);
      }
    }

    _onSelectChange() {
      const variant = this._getVariantFromOptions();

      this._updateAddToCartState(variant);

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateProductPrices(variant);
      this._switchToVariantImage(variant);
      this._onExtraProductRadioChange();
      this._updateSellingPlan(variant);
      this._updateOptionDisplays(variant);
      this._doKlarnaPlacements(variant);
      this._updateBundleProducts(variant);

      this._variant = variant;

      if (this._options.historyState) {
        this._updateHistoryState(variant);
      }
    }

    _updateBundleProducts(variant) {
      for (const bundleElem of this._bundleProducts) {
        const imageElem = bundleElem.querySelector('[data-bundle-product-image]');
        const jsonElem = bundleElem.querySelector('[data-bundle-product-json]');
        const priceElems = bundleElem.querySelectorAll('[data-bundle-product-price]');
        const comparePriceElems = bundleElem.querySelectorAll('[data-bundle-product-compare-price]');
        const variantIdElem = bundleElem.querySelector('[name="id"]');
        const bundleVariants = JSON.parse(jsonElem.innerHTML);
        let matchingVariant = null;

        for (const bundleVariant of bundleVariants) {
          if (bundleVariant.options.every((option) => variant.options.includes(option))) {
            matchingVariant = bundleVariant;
          }
        }

        if (matchingVariant) {
          if (matchingVariant.featured_image) {
            const imageSrc = Helpers.getSizedImageUrl(matchingVariant.featured_image.src, '240x');
            imageElem.src = imageSrc;
          }

          for (const elem of priceElems) {
            elem.innerHTML = this._formatMoney(matchingVariant.price);
          }

          // Faithful quirk: the compare price is never hidden/cleared when
          // the matching bundle variant has no compare_at_price.
          if (matchingVariant.compare_at_price) {
            for (const elem of comparePriceElems) {
              elem.innerHTML = this._formatMoney(matchingVariant.compare_at_price);
            }
          }

          variantIdElem.value = matchingVariant.id;
        }
      }
    }

    _doKlarnaPlacements(variant) {
      for (const placement of this._klarnaPlacements) {
        placement.setAttribute('data-purchase_amount', variant.price);
      }

      // Only refresh when the Klarna on-site messaging script is actually
      // present (the legacy bundle created the array itself and pushed
      // unconditionally).
      if (window.KlarnaOnsiteService) {
        window.KlarnaOnsiteService.push({
          eventName: 'refresh-placements',
        });
      }
    }

    _updateOptionDisplays(variant) {
      for (const option of this._optionDisplays) {
        option.innerHTML = variant[option.dataset.optionDisplay];
      }
    }

    _updateSellingPlan(variant) {
      if (!this._sellingPlanInput) return false;
      this._sellingPlanInput.value = '';
      this._sellingPlan = null;

      // Faithful quirk: always auto-picks the FIRST allocation — no picker.
      if (variant.selling_plan_allocations.length > 0) {
        this._sellingPlan = variant.selling_plan_allocations[0].selling_plan_id;
        this._sellingPlanInput.value = this._sellingPlan;
      }
    }

    _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}`;

      if (this._sellingPlan) {
        newurl += `&selling_plan=${this._sellingPlan}`;
      }

      window.history.replaceState({ path: newurl }, '', newurl);
    }

    _updateAddToCartState(variant) {
      if (!variant && this._product.available) {
        for (const addToCart of this._addToCarts) {
          addToCart.setAttribute('disabled', 'disabled');
          const sub = addToCart.querySelector('[data-add-to-cart-text]') || addToCart;
          sub.innerHTML = this._ctx.getState().locale.makeASelection;
        }
        return;
      }

      if (!variant) {
        return;
      }

      const in_stock = variant.available;

      if (in_stock) {
        for (const addToCart of this._addToCarts) {
          addToCart.removeAttribute('disabled');
          const sub = addToCart.querySelector('[data-add-to-cart-text]') || addToCart;
          // Faithful quirk: reads the selling plan from the PREVIOUS change
          // cycle (_updateSellingPlan runs later in the pipeline), so the
          // Subscribe label lags one change behind.
          if (this._sellingPlan) {
            sub.innerHTML = this._ctx.getState().locale.subscribe;
          } else {
            sub.innerHTML = this._ctx.getState().locale.addToCart;
          }
        }
      } else {
        for (const addToCart of this._addToCarts) {
          addToCart.setAttribute('disabled', 'disabled');
          const sub = addToCart.querySelector('[data-add-to-cart-text]') || addToCart;
          sub.innerHTML = this._ctx.getState().locale.soldOut;
        }
      }
    }

    _switchToVariantImage(variant) {
      for (const productImage of this._images) {
        if (productImage.dataset.productImage) {
          const idArray = productImage.dataset.productImage.split(',');
          if (idArray.includes(variant.id.toString())) {
            // Hidden contract: the media slider must be a keen-slider
            // registered with options id "mainProductSlider".
            const mainSlider = this._theme.getComponent('mainProductSlider');
            if (mainSlider) {
              mainSlider.component.goToSlide(productImage.dataset.index);
            }
          }
        }
      }
    }

    _updateProductPrices(variant) {
      for (const varies of this._priceVaries) {
        varies.classList.add('hide');
      }

      for (const productPrice of this._prices) {
        if (variant.compare_at_price > variant.price) {
          productPrice.classList.add('on-sale');
        } else {
          productPrice.classList.remove('on-sale');
        }
        productPrice.innerHTML = this._formatMoney(variant.price);
      }

      for (const productComparePrice of this._comparePrices) {
        if (variant.compare_at_price > variant.price) {
          productComparePrice.classList.remove('hide');
          const sub = productComparePrice.querySelector('[data-money]') || productComparePrice;
          sub.innerHTML = this._formatMoney(variant.compare_at_price);
        } else {
          productComparePrice.classList.add('hide');
          const sub = productComparePrice.querySelector('[data-money]') || productComparePrice;
          sub.innerHTML = '';
        }
      }
    }

    _formatMoney(price) {
      return Helpers.formatMoney(price, this._ctx.getState());
    }

    _updateMasterSelect(variant) {
      for (const originalSelector of this._masterSelects) {
        originalSelector.value = variant.id;
      }
    }

    _getCurrentOptions() {
      let currentOptions = [];

      for (const optionSelector of this._variantOptionTriggers) {
        const type = optionSelector.getAttribute('type');
        const currentOption = {};
        let alreadyDone = false;

        for (const option of currentOptions) {
          if (option.index === optionSelector.dataset.index) {
            alreadyDone = true;
          }
        }

        if (alreadyDone) continue;

        if (type === 'radio' || type === 'checkbox') {
          if (optionSelector.checked) {
            currentOption.value = optionSelector.value;
            currentOption.index = optionSelector.dataset.index;
            currentOptions.push(currentOption);
          } else {
            currentOptions.push(false);
          }
        } else {
          currentOption.value = optionSelector.value;
          currentOption.index = optionSelector.dataset.index;
          currentOptions.push(currentOption);
        }
      }

      currentOptions = Helpers.compact(currentOptions);
      return currentOptions;
    }

    _getVariantFromOptions() {
      const selectedValues = this._getCurrentOptions();
      const variants = this._product.variants;
      let found = false;

      for (const radio of this._variantRadios) {
        if (radio.checked) {
          return this._product.variants.find(
            (variant) => `${variant.id}` === radio.dataset.variantId
          );
        }
      }

      if (selectedValues.length > 0) {
        for (const variant of variants) {
          let satisfied = true;
          for (const option of selectedValues) {
            if (satisfied) {
              satisfied = option.value === variant[option.index];
            }
          }
          if (satisfied) {
            found = variant;
          }
        }
      }

      if (!found) {
        return this._product.variants.find(
          (variant) => `${variant.id}` === `${this._masterSelects[0].value}`
        );
      }

      return found || null;
    }
  }

  /* ===================================================================== *
   *  LazyLoadComp — vanilla-lazyload wrapper
   * ===================================================================== */
  class LazyLoadComp extends Component {
    constructor(elem, theme, options, ctx) {
      super(elem, theme, options, ctx);
      this._options = {
        elements_selector: '[data-lazy]',
        callback_loaded: (e) => {
          if (e.parentNode.nodeName === 'PICTURE') {
            e.parentNode.classList.add('loaded');
          }
          if (e.nodeName === 'VIDEO') {
            this._ctx.emit('ffc--video-loaded', null, e);
          }
        },
        callback_error: (e) => {
          if (e.parentNode.nodeName === 'PICTURE') {
            e.parentNode.classList.add('error');
          }
        },
        threshold: 500,
        ...this._options,
      };
      this._lazyLoad = null;
    }

    mount() {
      this._lazyLoad = new LazyLoadLib(this._options);

      this._ctx.on('ffc--lazy-load-update', () => {
        this._lazyLoad.update();
      });

      this._ctx.on('ffc--lazy-load-elem', (state, elem) => {
        LazyLoadLib.load(elem, this._options);
      });

      document.addEventListener('ffc--lazy-load-update', () => {
        this._lazyLoad.update();
      });
    }
  }

  /* ===================================================================== *
   *  LazyLoadTrigger — "when X happens, lazy-load Y" bridge
   * ===================================================================== */
  class LazyLoadTrigger extends Component {
    mount() {
      if (this._options.length) {
        for (const option of this._options) {
          this._optionLogic(option);
        }
      } else {
        this._optionLogic(this._options);
      }
    }

    _optionLogic(option) {
      if (!option.on) {
        option.on = 'click';
      }

      if (option.whenOutside) {
        document.addEventListener(option.on, (e) => {
          const clickIsInside = this._elem.contains(e.target) || this._elem === e.target;
          const toExclude = document.querySelectorAll(option.whenOutsideExcept);
          const hasClickedExclude = Array.from(toExclude).some(
            (elem) => elem.contains(e.target) || elem === e.target
          );
          if (clickIsInside || hasClickedExclude) return false;
          this._eventLogic(option, e);
        }, option.preventDefault ? { passive: false } : { passive: true });
      } else {
        // Faithful quirk: a single shared field — with an array of options
        // only the LAST handler is remembered for one-shot removal.
        this._eventListener = (e) => {
          this._eventLogic(option, e);
        };
        this._elem.addEventListener(
          option.on,
          this._eventListener,
          option.preventDefault ? { passive: false } : { passive: true }
        );
      }
    }

    _lazyLoadElem(option, elem) {
      this._ctx.emit('ffc--lazy-load-elem', null, elem);

      if (this._eventListener) {
        this._elem.removeEventListener(option.on, this._eventListener);
      }
    }

    _eventLogic(option, e) {
      if (option.onlyThisElem && e.target !== this._elem) {
        return false;
      }

      if (option.preventDefault) {
        e.preventDefault();
      }

      let elem = null;

      if (option.target.includes('closest:')) {
        const parentSelector = option.target.split('closest:')[1].trim();
        if (option.subTarget) {
          elem = this._elem.closest(parentSelector).querySelector(option.subTarget);
        } else {
          elem = this._elem.closest(parentSelector);
        }
        this._lazyLoadElem(option, elem);
      } else if (option.target === 'this') {
        elem = this._elem;
        if (option.subTarget) {
          elem = this._elem.querySelector(option.subTarget);
        }
        this._lazyLoadElem(option, elem);
      } else {
        const targets = document.querySelectorAll(option.target);
        for (const target of targets) {
          this._lazyLoadElem(option, target);
        }
      }
    }
  }

  /* ===================================================================== *
   *  MegaMenu — desktop hover mega menu
   * ===================================================================== */
  class MegaMenu extends Component {
    constructor(elem, theme, options, ctx) {
      super(elem, theme, options, ctx);
      this._options = { historyState: false, ...this._options };
      this._navItems = this._elem.querySelectorAll('[data-nav-item]');
      this._megaMenus = this._elem.querySelectorAll('[data-mega-menu]');
      this._timeout = null;
    }

    mount() {
      for (const navItem of this._navItems) {
        navItem.addEventListener('mouseenter', () => {
          if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
          }

          for (const megaMenu of this._megaMenus) {
            megaMenu.classList.remove('open');
          }

          const megaMenu = navItem.nextElementSibling;

          if (megaMenu.hasAttribute('data-mega-menu')) {
            megaMenu.classList.add('open');
            navItem.classList.add('dropdown-open');
            document.body.classList.add('mega-menu--open');
          }
        });

        navItem.addEventListener('mouseleave', () => {
          this._timeout = setTimeout(() => {
            const megaMenu = navItem.nextElementSibling;
            if (megaMenu.hasAttribute('data-mega-menu')) {
              megaMenu.classList.remove('open');
              navItem.classList.remove('dropdown-open');
              document.body.classList.remove('mega-menu--open');
            }
          }, 500);
        });
      }

      for (const megaMenu of this._megaMenus) {
        const megaMenuInner = megaMenu.querySelector('[data-mega-menu-inner]');

        megaMenuInner.addEventListener('mouseenter', () => {
          if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
          }

          const navItem = megaMenu.previousElementSibling;
          megaMenu.classList.add('open');
          navItem.classList.add('dropdown-open');
          document.body.classList.add('mega-menu--open');
        });

        megaMenuInner.addEventListener('mouseleave', () => {
          const navItem = megaMenu.previousElementSibling;
          megaMenu.classList.remove('open');
          navItem.classList.remove('dropdown-open');
          document.body.classList.remove('mega-menu--open');
        });
      }
    }
  }

  /* ===================================================================== *
   *  SlideToggle — slide open/close a target element
   * ===================================================================== */
  class SlideToggle extends Component {
    mount() {
      if (this._options.length) {
        for (const option of this._options) {
          this._optionLogic(option);
        }
      } else {
        this._optionLogic(this._options);
      }
    }

    _optionLogic(option) {
      this._elem.addEventListener(option.on, async (e) => {
        if (option.preventDefault) {
          e.preventDefault();
        }

        const target = document.querySelector(option.selector);
        let method = null;

        if (option.method === 'slideDown') {
          method = '_slideDown';
        } else if (option.method === 'slideUp') {
          method = '_slideUp';
        } else {
          method = this._elem.classList.contains('open') ? '_slideUp' : '_slideDown';
        }

        if (option.useQueue) {
          this._ctx.getState().eventQueue.add(async () => this[method](target));
        } else {
          await this[method](target);
        }
      });
    }

    _slideDown(elem) {
      return new Promise((resolve) => {
        elem.style.maxHeight = 'none';
        const scrollHeight = elem.scrollHeight;
        elem.style.maxHeight = '0px';
        this._elem.classList.add('open');
        elem.dataset.transitioning = true;

        const openEvent = (e) => {
          if (e.propertyName === 'max-height') {
            elem.dataset.transitioning = false;
            elem.style.maxHeight = 'none';
            elem.classList.add('open');
            elem.removeEventListener('transitionend', openEvent, false);
            document.dispatchEvent(new Event('ffc--update-sticky'));
            resolve();
          }
        };

        elem.addEventListener('transitionend', openEvent, false);
        Helpers.nextFrame(() => {
          elem.style.maxHeight = `${scrollHeight}px`;
        });
      });
    }

    _slideUp(elem) {
      return new Promise((resolve) => {
        elem.style.maxHeight = `${elem.scrollHeight}px`;
        this._elem.classList.remove('open');
        elem.dataset.transitioning = true;

        const closeEvent = (e) => {
          if (e.propertyName === 'max-height') {
            elem.removeEventListener('transitionend', closeEvent, false);
            elem.dataset.transitioning = false;
            document.dispatchEvent(new Event('ffc--update-sticky'));
            resolve();
          }
        };

        elem.addEventListener('transitionend', closeEvent, false);
        Helpers.nextFrame(() => {
          elem.style.maxHeight = '0px';
          elem.classList.remove('open');
        });
      });
    }
  }

  /* ===================================================================== *
   *  SlideToggleGroup — accordion group of [data-toggle-item]s
   * ===================================================================== */
  class SlideToggleGroup extends Component {
    constructor(elem, theme, options, ctx) {
      super(elem, theme, options, ctx);
      this._toggleItems = this._elem.querySelectorAll('[data-toggle-item]');
    }

    mount() {
      if (this._options.closeOnOutsideClick && matchMedia('only screen and (min-width: 835px)').matches) {
        document.addEventListener('click', (e) => {
          const clickIsInside = this._elem.contains(e.target) || this._elem === e.target;
          if (clickIsInside) return false;

          for (const item of this._toggleItems) {
            const elemToSlide = item.querySelector('[data-toggle-elem]');
            if (item.classList.contains('open')) {
              Helpers.slideUp(elemToSlide, item);
            }
          }
        }, { passive: true });
      }

      for (const item of this._toggleItems) {
        const trigger = item.querySelector('[data-toggle-trigger]');
        if (!trigger) continue; // CS-FIX: legacy bundle crashed here on toggle items without a trigger (error was caught, component died)
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const elemToSlide = item.querySelector('[data-toggle-elem]');

          if (elemToSlide.dataset.transitioning === 'true') {
            return false;
          }

          if (item.classList.contains('open')) {
            Helpers.slideUp(elemToSlide, item);
          } else {
            Helpers.slideDown(elemToSlide, item);
          }

          const otherToggles = item.parentNode.querySelectorAll('[data-toggle-item]');
          for (const otherItem of otherToggles) {
            if (otherItem !== item && otherItem.classList.contains('open') && otherItem.dataset.transitioning !== 'true') {
              const otherElemToSlide = otherItem.querySelector('[data-toggle-elem]');
              Helpers.slideUp(otherElemToSlide, otherItem);
            }
          }
        });
      }
    }
  }

  /* ===================================================================== *
   *  AnnouncementBar — closable top bar (localStorage-persisted)
   * ===================================================================== */
  class AnnouncementBar extends Component {
    constructor(elem, theme, options, ctx) {
      super(elem, theme, options, ctx);
      this._closeButton = this._elem.querySelector('[data-announcement-bar-close]');
    }

    mount() {
      const currentTime = new Date().getTime();

      if (this._closeButton) // CS-FIX: legacy bundle crashed when the bar had no close button
      this._closeButton.addEventListener('click', () => {
        this._elem.style.height = `${this._elem.clientHeight}px`;
        const newEpoch = currentTime + 1000 * 60 * 60 * 24 * this._options.daysToHide;
        document.body.classList.add('can-transition');
        localStorage.setItem('ffc--announcement-bar-closed', newEpoch);
        Helpers.nextFrame(() => {
          const height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
          const newHeight = height - this._elem.clientHeight;
          document.documentElement.style.setProperty('--header-height', `${newHeight}px`);

          const transitionEnd = () => {
            this._ctx.emit('ffc--sticky-refresh');
            this._elem.removeEventListener('transitionend', transitionEnd);
          };

          this._elem.addEventListener('transitionend', transitionEnd);
          this._elem.style.height = '0px';
        });
      });

      let shouldShow = true;

      if (localStorage.getItem('ffc--announcement-bar-closed')) {
        const epoch = localStorage.getItem('ffc--announcement-bar-closed');
        if (epoch > currentTime) {
          shouldShow = false;
        }
      }

      if (shouldShow) {
        this._elem.classList.add('shown');
        this._ctx.emit('ffc--update-css-var', null, {});
        this._ctx.emit('ffc--sticky-refresh');
      }
    }
  }

  /* ===================================================================== *
   *  Sticky — closable sticky container / bottom bar (registry key
   *  "sticky-container"; localStorage-persisted)
   * ===================================================================== */
  class Sticky extends Component {
    constructor(elem, theme, options, ctx) {
      super(elem, theme, options, ctx);
      this._closeButton = this._elem.querySelector('[data-sticky-container-close]');
      this._body = document.querySelector('body');
    }

    mount() {
      const currentTime = new Date().getTime();

      if (this._closeButton) // CS-FIX: same guard for sticky container
      this._closeButton.addEventListener('click', () => {
        this._elem.style.height = `${this._elem.clientHeight}px`;
        this._body.style.paddingBottom = '0px';
        const newEpoch1 = currentTime + 1000 * 60 * 60 * 24 * this._options.daysToHide;
        document.body.classList.add('can-transition');
        localStorage.setItem('ffc--sticky-container-closed', newEpoch1);
        Helpers.nextFrame(() => {
          const height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
          const newHeight = height - this._elem.clientHeight;
          document.documentElement.style.setProperty('--header-height', `${newHeight}px`);

          const transitionEnd = () => {
            this._ctx.emit('ffc--sticky-refresh');
            this._elem.removeEventListener('transitionend', transitionEnd);
          };

          this._elem.addEventListener('transitionend', transitionEnd);
          this._elem.style.height = '0px';
        });
      });

      let shouldShow = true;

      if (localStorage.getItem('ffc--sticky-container-closed')) {
        const epoch = localStorage.getItem('ffc--sticky-container-closed');
        if (epoch > currentTime) {
          shouldShow = false;
        }
      }

      if (shouldShow) {
        this._elem.classList.add('shown');
        this._ctx.emit('ffc--update-css-var', null, {});
        this._ctx.emit('ffc--sticky-refresh');
        this._body.style.paddingBottom = `${this._elem.clientHeight}px`;
      }
    }
  }

  /* ===================================================================== *
   *  StickyElem — hc-sticky wrapper (registry key "sticky"). hc-sticky is
   *  inlined above and loaded eagerly, so mount is synchronous (the legacy
   *  async mount only existed for the dynamic webpack chunk import).
   * ===================================================================== */
  class StickyElem extends Component {
    constructor(elem, theme, options, ctx) {
      super(elem, theme, options, ctx);
      this._sticky = null;
      // Faithful quirk: overrides the processed copy from the Component base
      // with the raw options reference (responsive tiers never applied here).
      this._options = options;
      this._selector = this._options.top;
    }

    mount() {
      if (typeof this._selector === 'string') {
        this._options.top = document.querySelector(this._selector).getBoundingClientRect().height;
      }

      this._sticky = new hcSticky(this._elem, this._options);

      if (typeof this._selector === 'string') {
        window.addEventListener('resize', () => {
          this._options.top = document.querySelector(this._selector).getBoundingClientRect().height;
          this._sticky.update(this._options);
        }, { passive: true });
      }
    }
  }

  /* ===================================================================== *
   *  Theme — component registry, boot, viewport CSS vars, analytics hooks
   * ===================================================================== */
  const components = {
    'lazy-load': LazyLoadComp,
    'lazy-load-trigger': LazyLoadTrigger,
    'keen-slider': KeenSliderComp,
    'product': Product,
    'mega-menus': MegaMenu,
    'slide-toggle': SlideToggle,
    'toggle-group': SlideToggleGroup,
    'add-to-cart': AddToCart,
    'sticky': StickyElem,
    'announcement-bar': AnnouncementBar,
    'sticky-container': Sticky,
  };

  const options = {
    turbolinks: false,
  };

  const state = {
    eventQueue: new Queue(),
    ajaxCache: [],
  };

  class Theme {
    constructor(ctx = state, passedOptions = {}) {
      this._options = { ...passedOptions, ...options };
      const themeInfoElem = document.querySelector('[data-theme-information]');

      if (themeInfoElem) {
        ctx = { ...ctx, ...JSON.parse(themeInfoElem.innerHTML) };
      }

      this._ctx = evx.create(ctx);
      this._viewportEvent();
      this._bodyScrollListen();
      this._runHooks();
      this._components = [];
    }

    _viewportEvent() {
      window.addEventListener('resize', () => {
        this._viewportLogic();
      }, { passive: true });

      this._viewportLogic();
    }

    _bodyScrollListen() {
      const targetNode = document.body;
      const config = { attributes: true, childList: false, subtree: false };

      const callback = () => {
        document.documentElement.style.setProperty('--scroll-gap-right', getComputedStyle(document.body).paddingRight);
      };

      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }

    _viewportLogic() {
      const vh = window.innerHeight * 0.01;
      const vw = document.body.clientWidth * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('--vw', `${vw}px`);
    }

    mountComponents(container = document) {
      for (const componentKey of Object.keys(components)) {
        const selector = `[data-${componentKey}]`;
        const elements = container.querySelectorAll(selector);
        for (const elem of elements) {
          this.mountComponent(componentKey, componentKey, elem);
        }
      }

      window.__Theme = this;
      window.__ThemeComponents = this._components;

      this._ctx.emit('ffc--mounted');
    }

    unmountComponents(container = document) {
      for (let i = this._components.length - 1; i >= 0; i--) {
        let component = this._components[i];

        if (container.contains(component.elem)) {
          let componentObj = component.component;

          if (typeof componentObj.unmount === 'function') {
            componentObj.unmount();
          }

          component = null;
          componentObj = null;

          this._components.splice(i, 1);
        }
      }
    }

    mountComponent(type, dataAttr, elem) {
      const optionStr = elem.getAttribute(`data-${dataAttr}`).trim();
      let componentOptions = {};

      if (optionStr.startsWith('{') || optionStr.startsWith('[')) {
        componentOptions = JSON.parse(optionStr);
      }

      const compInstance = new components[type](elem, this, componentOptions, this._ctx);

      this._components.push({
        type: type,
        elem: elem,
        id: compInstance._options.id,
        component: compInstance,
      });

      try {
        compInstance.mount();
      } catch (e) {
        console.error(`-----ERROR IN COMPONENT----- \ntype: ${type}\nelement and stack trace below:`);
        console.error(elem);
        console.error(e);
      }
    }

    getOptions() {
      return this._options;
    }

    getComponent(id) {
      return this._components.find((component) => component.id === id);
    }

    getComponentByElem(elem) {
      return this._components.find((component) => component.elem === elem);
    }

    _runHooks() {
      this._ctx.on('cart-item-added', (hookState) => {
        if (window.pintrk) {
          pintrk('track', 'addtocart', {
            value: hookState.lastItemAdded.item.price / 100.00,
            order_quantity: hookState.lastItemAdded.quantity,
          });
        }

        if (window.fbq) {
          fbq('track', 'AddToCart');
        }
      });
    }
  }

  /* ===================================================================== *
   *  Boot (legacy ffc.js entry module)
   * ===================================================================== */
  const theme = new Theme();
  theme.mountComponents();

  document.addEventListener('shopify:section:unload', (e) => {
    theme.unmountComponents(e.target);
  });

  document.addEventListener('shopify:section:load', (e) => {
    theme.mountComponents(e.target);
    theme._ctx.emit('ffc--lazy-load-update');
  });
})();
